angular.module('rightPaneModule')
.controller('TeacherClassesController', [
      '$scope',
      '$state',
      'authentication',
      'edxReportItemService',
      'timeframe',
      'classroomApi',
      'navigation',
      'reportErrors',
      'tableColumns',
      'tableSort',
      'teacherApi',
      function(
          $scope,
      	  $state,
          authentication,
          edxReportItemService,
          timeframe,
          $classroomApi,
          navigation,
          $reportErrors,
          tableColumns,
          tableSort,
          teacherApi) {

	$scope.years = { list: null, selected: {} };
	$scope.timeframes = {
		list: [
			{ id: '7d', name: 'Last 7 Days', by: 'day', active: true },
			{ id: '30d', name: 'Last 30 Days', by: 'week', active: false }
		],
		selected: {}
	};

    $scope.viewMode = authentication.growthAsFraction()  ? 'fractionMode' : 'percentMode';

    if ($scope.viewMode === 'fractionMode') {
        $scope.listTableColumns = tableColumns.getColumns('classroom');
    } else {
        $scope.listTableColumns = tableColumns.getColumns('classroom_with_growth');
    }

	var updateClasses = function() {
        $scope.classroomReportingUrl = $classroomApi.getClassroomsReportingExportUrl();

        $scope.classroomError = null;
    $scope.listTableData = undefined;
		$classroomApi.getClassroomsReporting().then(function(classes) {
			$scope.classes = classes;
            $scope.listTableData = tableSort.sortColumn($scope.listTableColumns, classes);
		}, function(error) {
            $scope.classes = undefined;
            $scope.listTableData = undefined;
            $scope.classroomError = $reportErrors.getErrorMessage(error);
        });
	};

    var updateHighlights = function () {
        var params = _.pick($state.params, ['districtId']);
        params.teacher_id = $state.params.teacherId;
        params = _.extend(params, timeframe.getTimeframeParams());

        $scope.teacherData = undefined;
        teacherApi.getTeacherHighlights(params).then(function (teacherData) {
            $scope.teacherData = teacherData;
        });
    };

    var updateData = function () {
        updateClasses();
        updateHighlights();
    };

    var updateTableSort = function () {
        if ($scope.listTableData) {
            $scope.listTableData = tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
        }
    };

    var initializeData = function(item) {
        $scope.item = item;
    };

	var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(function (item) {
        initializeData(item);
  	});

    $scope.$on('yearSelected', function(e, item) {
        updateClasses();
    });

    $scope.$on('updateSortableTable', updateTableSort);
    $scope.$on('timeframeSelected', updateData);
    $scope.$on('timeframeInitialized', updateData);
    $scope.$on('listTableRowClicked', function (e, item) {
        navigation.goToItem(item);
    });

    var timeframeSubscription = timeframe.getYearListSubject().subscribe(function (years) {
        $scope.years.list = angular.copy(years);
    });

    $scope.$on('$destroy', function () {
        itemSubscription.dispose();
        timeframeSubscription.dispose();
    });
}]);
